import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional} from '@angular/core';
import { Location, NgClass, NgStyle, UpperCasePipe } from '@angular/common';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {appearSlowlyAnimation} from 'src/app/features/cookie-modal/cookie-modal-animation';
import {BeforeLoginService} from 'src/app/services/before-login.service';
import {TermsText} from 'src/app/services/contact-info.service';
import {DeviceDetectService} from '../../../services/device-detect.service';
import {SessionContext} from '../../../models/session-context.model';
import {Subscription} from "rxjs";
import {environment} from "../../../../environments/environment";
import {TagConversionPipe} from '../../../pipes/tag-conversion.pipe';
import {Consent, ConsentService} from "../../../services/consent.service";
import {PageContentHeaderComponent} from "../../../shared/components/page-content-header/page-content-header.component";
import {LinkHandlerDirective} from "../../../directives/link-handler.directive";
import {UserInfoService} from "../../../services/user-info.service";
import {UserConsentService} from "../../../services/user-consent.service";
import {SessionStorageService} from "../../../services/session-storage.service";


@Component({
    selector: "app-prescription-consent-modal",
    templateUrl: "./prescription-consent-modal.component.html",
    styleUrls: ["./prescription-consent-modal.component.css"],
    animations: [appearSlowlyAnimation],
  imports: [
    TagConversionPipe,
    TranslateModule,
    PageContentHeaderComponent,
    LinkHandlerDirective,
    NgClass,
    NgStyle,
    UpperCasePipe
]
})
export class PrescriptionConsentModalComponent implements OnInit, OnDestroy {

  isRenewPrescriptionPage: boolean = false;

  private modalOpenSubscription: Subscription;
  showModal: boolean;
  isMobile: boolean;
  selectedLang: string = "et";
  termsText: TermsText;
  previousCheckboxState: boolean;
  sessionContext: SessionContext = JSON.parse(
    sessionStorage.getItem("sessionContext"),
  );

  receivedURL: string | null = null;
  isUrlFetching: boolean;
  isHpMedicationPage: boolean = false;

  constructor(
    private translate: TranslateService,
    private dialogRef: MatDialogRef<PrescriptionConsentModalComponent>,
    private router: Router,
    public beforeLoginService: BeforeLoginService,
    private deviceDetectService: DeviceDetectService,
    private location: Location,
    private consentService: ConsentService,
    private userConsentService: UserConsentService,
    private sessionStorageService: SessionStorageService,
    private userInfoService: UserInfoService,
    private cdRef: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) data: { previousCheckboxState?: boolean },
  ) {
    this.previousCheckboxState = data.previousCheckboxState || false;
  }
  expandText: boolean = false;
  prescriptionConsent: string;
  prescriptionParam = "I62_EPAK_RETS_RETSEPTIDE_INFO_PATSIENT";

  ngOnInit(): void {
    this.selectedLang = this.translate.currentLang;
    this.isMobile = this.deviceDetectService.isMobile;
    this.identifyCurrentPage();
    this.modalOpenSubscription = this.dialogRef.afterOpened().subscribe(() => {
      if (!this.previousCheckboxState) {
        this.fetchPrescriptionConsentInfo();
      }
    });

    this.beforeLoginService
      .fetchTerms(this.selectedLang, "PRESCRIPTION_CONSENT")
      .then((data) => {
        if (data && data.body) {
          this.termsText = data.body;
        }
      });
    setTimeout(() => {
      this.showModal = true;
    }, 1000);
  }

  fetchPrescriptionConsentInfo(): void {
    this.isUrlFetching = true;
    let isPremiumService: boolean = false;
    if (this.router.url.includes("/paid-prescriptions")) {
      isPremiumService = true;
    }
    this.consentService.getRequestConsent([this.prescriptionParam], isPremiumService).then(() => {
      const fetchedRefs: Consent = this.consentService.fetchedConsentRefs;
      if (fetchedRefs && fetchedRefs.validPurposeDeclarationIds) {
        this.prescriptionConsent = fetchedRefs.validPurposeDeclarationIds[environment.consentService.prescriptionDeclarationId];
      }

      if (fetchedRefs.returnedUrl && fetchedRefs.returnedUrl.url) {
        this.receivedURL = fetchedRefs.returnedUrl.url;
        this.consentService.updateReturnedUrl(this.receivedURL);
      }

      this.isUrlFetching = false;
      this.cdRef.detectChanges();

      if (this.isRenewPrescriptionPage || this.isHpMedicationPage) {
        this.userConsentService.checkConsentStatus();
      }

    }).catch((error) => {
      console.error('Error fetching prescription consent:', error);
      this.isUrlFetching = false;
      this.cdRef.detectChanges();
    });
  }


  onAccept(setSessionStorage: boolean = false) {
    if (setSessionStorage) {
      this.sessionStorageService.setRedirectedToNtPage();
      sessionStorage.setItem("toNtPage", "true");
    }
    //If we don't have prescription consent we pass termsText.accepted "false"
    // because consent is not accepted yet in consent service.
    this.termsText.accepted = !!this.prescriptionConsent;
    setTimeout(() => {
      this.dialogRef.close({
        termsText: this.termsText,
        prescriptionConsent: this.prescriptionConsent,
      });
      sessionStorage.removeItem("PRESCRIPTIONS");
      sessionStorage.removeItem("PATCH_FORM");
    }, 1000);
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.modalOpenSubscription) {
      this.modalOpenSubscription.unsubscribe();
    }
  }

  private identifyCurrentPage(): void {
    this.isHpMedicationPage = this.router.url === "/health-plan/medication";
    this.isRenewPrescriptionPage = this.router.url === "/prescriptions";
  }
}
